function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 1a1 1 0 011 1v5h5a1 1 0 010 2H8.999L9 14a1 1 0 01-2 0l-.001-5H2a1 1 0 010-2h5V2a1 1 0 011-1z"
});

var SvgPlus = function SvgPlus(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTggMWMuNTUyIDAgMSAuNDQ4IDEgMXY1aDVjLjU1MiAwIDEgLjQ0OCAxIDFzLS40NDggMS0xIDFIOC45OTlMOSAxNGMwIC41NTItLjQ0OCAxLTEgMXMtMS0uNDQ4LTEtMWwtLjAwMS01SDJjLS41NTIgMC0xLS40NDgtMS0xcy40NDgtMSAxLTFoNVYyYzAtLjU1Mi40NDgtMSAxLTF6Ii8+Cjwvc3ZnPgo=";
export { SvgPlus as ReactComponent };